import { Component, inject, input, type OnInit } from '@angular/core';
import type { HomeBatteryCapacityAdviceRendering } from '@feh/homebattery-models';
import {
  calculateBatteryCapacity,
  selectHomebatteryBatteryCapacity,
} from '@feh/homebattery-store';
import { HomebatteryCapacityAdviceUiComponent } from '@feh/homebattery-ui';
import { Store } from '@ngrx/store';
import * as Sentry from '@sentry/angular';

@Sentry.TraceClass({ name: 'FEIT-Homebattery-Capacity-Advice-Container' })
@Component({
  selector: 'wl-homebattery-capacity-advice-container',
  standalone: true,
  templateUrl: './homebattery-capacity-advice-container.component.html',
  imports: [HomebatteryCapacityAdviceUiComponent],
})
export class HomebatteryCapacityAdviceContainerComponent implements OnInit {
  public readonly rendering =
    input.required<HomeBatteryCapacityAdviceRendering>();
  private readonly store = inject(Store);
  public readonly batteryCapacity = this.store.selectSignal(
    selectHomebatteryBatteryCapacity
  );

  ngOnInit(): void {
    this.store.dispatch(calculateBatteryCapacity());
  }
}
